import React from "react";
import { AlertTriangle } from "lucide-react";
import { cn } from "../../utils/classMerger";

interface InlineWarningProps {
    message: string;
    className?: string;
}

export default function InlineWarning({ message, className }: InlineWarningProps) {
    const lines = message.split("\n");
    return (
        <div
            className={cn(
                "mt-2 p-3 flex items-start gap-2 border border-red-300 bg-red-50 rounded-lg text-sm text-red-600",
                className
            )}
        >
            <AlertTriangle className="h-4 w-4 flex-shrink-0 self-center" />
            <span className="leading-5">
                {lines.map((line, i) => (
                    <React.Fragment key={i}>
                        {line}
                        {i < lines.length - 1 && <br />}
                    </React.Fragment>
                ))}
            </span>
        </div>
    );
}
